import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/cc-developer-platform-pages/cc-developer-platform-pages/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import { clouds, products } from '../products';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const AnnouncementBlock = makeShortcode("AnnouncementBlock");
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const ResourceCard = makeShortcode("ResourceCard");
const OldProductCardGrid = makeShortcode("OldProductCardGrid");
const SummaryBlock = makeShortcode("SummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    {/* Hero */}
    <Hero slots="image, heading, icon, text, buttons" variant="halfwidth" mdxType="Hero" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/5530d/cc-hero.webp 320w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/0c8fb/cc-hero.webp 640w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/94b1e/cc-hero.webp 1280w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/6b378/cc-hero.webp 1492w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/dd4a7/cc-hero.png 320w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/0f09e/cc-hero.png 640w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/bbbf7/cc-hero.png 1280w", "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/37cfc/cc-hero.png 1492w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/e61ab496c82d13153b9a8276f583ed03/bbbf7/cc-hero.png",
            "alt": "cc hero",
            "title": "cc hero",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h1 {...{
      "id": "build-for-creative-cloud"
    }}>{`Build for Creative Cloud`}</h1>
    <p><img parentName="p" {...{
        "src": "https://adobe.io/shared/icons/cc_appicon_64.svg",
        "alt": "Creative Cloud"
      }}></img></p>
    <p>{`The Creative Cloud Developer Platform is a collection of APIs and SDKs that let you extend and integrate with Creative Cloud apps and services, which are used by millions of people around the world. From automating workflows to integrating your software with Creative Cloud, our developer platform has the tools you need to power creativity.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#api-list"
        }}>{`Browse our APIs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/console"
        }}>{`Visit the Developer Console`}</a></li>
    </ul>
    {/* Newsletter */}
    <AnnouncementBlock slots="heading, text, button" theme="dark" mdxType="AnnouncementBlock" />
    <h3 {...{
      "id": "subscribe-to-the-creative-cloud-developer-newsletter"
    }}>{`Subscribe to the Creative Cloud Developer Newsletter`}</h3>
    <p>{`Be the first to hear about API launches, technology updates, marketplace news, developer events, and more by joining our newsletter.`}</p>
    <p><a parentName="p" {...{
        "href": "http://adobe.ly/devnews"
      }}>{`Sign up today`}</a></p>
    {/* Extend, Integrate, Distribute */}
    <TitleBlock slots="heading, text" theme="lightest" mdxType="TitleBlock" />
    <h1 {...{
      "id": "extend-integrate-distribute"
    }}>{`Extend. Integrate. Distribute.`}</h1>
    <p>{`All on the Creative Cloud Developer Platform.`}</p>
    <TextBlock slots="image, heading, text1, links" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/5530d/cc-extend-3.webp 320w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/0c8fb/cc-extend-3.webp 640w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/94b1e/cc-extend-3.webp 1280w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/0b34d/cc-extend-3.webp 1920w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/dd4a7/cc-extend-3.png 320w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/0f09e/cc-extend-3.png 640w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/bbbf7/cc-extend-3.png 1280w", "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/ac7a9/cc-extend-3.png 1920w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/a6c5f7e4d56c245ea5917e65b2c252c6/bbbf7/cc-extend-3.png",
            "alt": "cc extend 3",
            "title": "cc extend 3",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "extend-adobe-creative-cloud-apps"
    }}>{`Extend Adobe Creative Cloud apps`}</h2>
    <p>{`Creative Cloud desktop apps offer APIs and SDKs that let you take them to new heights. Automate workflows, build new features, and connect Creative Cloud to other software and services. Write plugins or scripts, with or without UI, that tailor our industry-leading creative apps to individuals’ unique creative needs. `}<a parentName="p" {...{
        "href": "#api-list"
      }}>{`Browse the full list.`}</a></p>
    <p><img parentName="p" {...{
        "src": "https://developer.adobe.com/shared/icons/adobe_express_appicon_64px.svg",
        "alt": "Express"
      }}></img><a parentName="p" {...{
        "href": "../express"
      }}>{`Express`}</a>{` `}{` `}{` `}{` `}{`
`}<img parentName="p" {...{
        "src": "https://developer.adobe.com/shared/icons/ps_appicon_64.svg",
        "alt": "Photoshop"
      }}></img><a parentName="p" {...{
        "href": "../photoshop"
      }}>{`Photoshop`}</a>{` `}{` `}{` `}{` `}{`
`}<img parentName="p" {...{
        "src": "https://developer.adobe.com/shared/icons/id_appicon_64.svg",
        "alt": "InDesign"
      }}></img><a parentName="p" {...{
        "href": "../indesign/uxp"
      }}>{`InDesign`}</a>{`  `}{` `}</p>
    <TextBlock slots="image, heading, text1, links" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.68750000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/5530d/cc-desktop-marketplace-1.webp 320w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/0c8fb/cc-desktop-marketplace-1.webp 640w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/94b1e/cc-desktop-marketplace-1.webp 1280w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/0b34d/cc-desktop-marketplace-1.webp 1920w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/d5269/cc-desktop-marketplace-1.webp 2560w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/e1a50/cc-desktop-marketplace-1.webp 2784w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/dd4a7/cc-desktop-marketplace-1.png 320w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/0f09e/cc-desktop-marketplace-1.png 640w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/bbbf7/cc-desktop-marketplace-1.png 1280w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/ac7a9/cc-desktop-marketplace-1.png 1920w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/c7a69/cc-desktop-marketplace-1.png 2560w", "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/9ddde/cc-desktop-marketplace-1.png 2784w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/09debba69d790b95ddf5d68b2e3956a1/bbbf7/cc-desktop-marketplace-1.png",
            "alt": "Creative Cloud Desktop Marketplace",
            "title": "Creative Cloud Desktop Marketplace",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "distribute-to-millions-of-users-worldwide"
    }}>{`Distribute to millions of users worldwide`}</h2>
    <p>{`Publish your plugins and integrations directly to the Marketplace in the Creative Cloud Desktop app for users to easily discover, install, and manage—and to the Enterprise Admin Console for admins to easily find, deploy, and give access to plugins and integrations intended for business use.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://exchange.adobe.com/creativecloud.html?route=discoverIntegrations&workflow=share"
        }}>{`Creative Cloud Plugin Marketplace`}</a></li>
    </ul>
    {/* Fund content */}
    <TitleBlock slots="heading, text" theme="light" mdxType="TitleBlock" />
    <h1 {...{
      "id": "the-adobe-fund-for-design"
    }}>{`The Adobe Fund for Design`}</h1>
    <p>{`Get funding to build Adobe Express add-ons — plugins and integrations that unleash the creativity of millions of users.`}</p>
    <ResourceCard slots="link, image, heading, text" width="50%" theme="light" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/fund-for-design"
      }}>{`Adobe Fund for Design`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1000px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "43.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/5530d/affd2024.webp 320w", "/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/0c8fb/affd2024.webp 640w", "/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/80c60/affd2024.webp 1000w"],
            "sizes": "(max-width: 1000px) 100vw, 1000px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/dd4a7/affd2024.png 320w", "/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/0f09e/affd2024.png 640w", "/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/1263b/affd2024.png 1000w"],
            "sizes": "(max-width: 1000px) 100vw, 1000px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/6dfb4004b6d9f18102d4f69b5b0f7132/1263b/affd2024.png",
            "alt": "affd2024",
            "title": "affd2024",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "the-adobe-fund-for-design-1"
    }}>{`The Adobe Fund for Design`}</h3>
    <p>{`Apply for a grant or investment.`}</p>
    <ResourceCard slots="link, image, heading, text" width="50%" theme="light" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://blog.developer.adobe.com/get-funding-to-build-adobe-express-add-ons-093ddf8336be?source=friends_link&sk=f04b558801adc66ec89f25d8589e400b"
      }}>{`Adobe Tech Blog | Get Funding to Build Adobe Express Add-Ons`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "640px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.93750000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/3353a8b764137baa012f2095293e7e1c/5530d/adobe-fund-for-design-2.webp 320w", "/creative-cloud/static/3353a8b764137baa012f2095293e7e1c/0c8fb/adobe-fund-for-design-2.webp 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/3353a8b764137baa012f2095293e7e1c/dd4a7/adobe-fund-for-design-2.png 320w", "/creative-cloud/static/3353a8b764137baa012f2095293e7e1c/0f09e/adobe-fund-for-design-2.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/3353a8b764137baa012f2095293e7e1c/0f09e/adobe-fund-for-design-2.png",
            "alt": "adobe fund for design 2",
            "title": "adobe fund for design 2",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "get-funding-to-build-adobe-express-add-ons"
    }}>{`Get Funding to Build Adobe Express Add-Ons`}</h3>
    <p>{`Adobe Tech Blog article`}</p>
    <TitleBlock slots="heading, text" theme="dark" mdxType="TitleBlock" />
    <h1 {...{
      "id": "the-creative-cloud-developer-community"
    }}>{`The Creative Cloud Developer Community`}</h1>
    <p>{`Multiple focuses. Many identities. A singular mission to empower creativity.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="dark" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/5530d/dev-days.webp 320w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/0c8fb/dev-days.webp 640w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/94b1e/dev-days.webp 1280w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/0b34d/dev-days.webp 1920w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/d5269/dev-days.webp 2560w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/0ca9a/dev-days.webp 5911w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/8980b/dev-days.jpg 320w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/56d4e/dev-days.jpg 640w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/62aaf/dev-days.jpg 1280w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/aaf92/dev-days.jpg 1920w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/36eba/dev-days.jpg 2560w", "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/23342/dev-days.jpg 5911w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/fa36dafdfdcf0db52debb97b763f113e/62aaf/dev-days.jpg",
            "alt": "dev days",
            "title": "dev days",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "multiple-focuses"
    }}>{`Multiple focuses`}</h3>
    <p>{`Creative Cloud developers can build plugins and scripts for a single Creative Cloud app, or multiple apps at once. Or they can integrate services from Adobe into their own products. Some developers do all of these things!`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="dark" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "66.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/5530d/workshop.webp 320w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/0c8fb/workshop.webp 640w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/94b1e/workshop.webp 1280w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/0b34d/workshop.webp 1920w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/d5269/workshop.webp 2560w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/f105b/workshop.webp 6000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/8980b/workshop.jpg 320w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/56d4e/workshop.jpg 640w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/62aaf/workshop.jpg 1280w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/aaf92/workshop.jpg 1920w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/36eba/workshop.jpg 2560w", "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/441eb/workshop.jpg 6000w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/1b8637ae8c0e44d49fd741a0be25f17d/62aaf/workshop.jpg",
            "alt": "workshop",
            "title": "workshop",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "many-identities"
    }}>{`Many identities`}</h3>
    <p>{`Creative Cloud developers may identify as `}<em parentName="p">{`developer`}</em>{`, `}<em parentName="p">{`scripter`}</em>{`, `}<em parentName="p">{`entrepreneur`}</em>{`, `}<em parentName="p">{`business owner`}</em>{`, and yes: `}<em parentName="p">{`creative`}</em>{` or `}<em parentName="p">{`artist`}</em>{`. Some have worked with Adobe APIs for many years; others are learning their first JavaScript today.`}</p>
    <TextBlock slots="image, heading, text" width="33%" theme="dark" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1080px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/5530d/partner-day.webp 320w", "/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/0c8fb/partner-day.webp 640w", "/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/5c666/partner-day.webp 1080w"],
            "sizes": "(max-width: 1080px) 100vw, 1080px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/dd4a7/partner-day.png 320w", "/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/0f09e/partner-day.png 640w", "/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/b4ad3/partner-day.png 1080w"],
            "sizes": "(max-width: 1080px) 100vw, 1080px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/bb121c894ce51f76e4b9e8a352dd3315/b4ad3/partner-day.png",
            "alt": "partner day",
            "title": "partner day",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "a-singular-mission"
    }}>{`A singular mission`}</h3>
    <p>{`No matter why or how they got here, Creative Cloud developers are on a mission to inspire and empower creatives to get more done in less time, collaborate in new ways, and push the boundaries of creativity.`}</p>
    <AnnouncementBlock slots="heading, text, button" theme="dark" mdxType="AnnouncementBlock" />
    <h2 {...{
      "id": "connect-with-our-community"
    }}>{`Connect with our community`}</h2>
    <p>{`We're rolling out a new set of forums for developers. We have categories for a selection of APIs to start, with support for more on the way.`}</p>
    <p><a parentName="p" {...{
        "href": "https://forums.creativeclouddeveloper.com"
      }}>{`Join the Creative Cloud Developer Forums`}</a></p>
    {/* Partners */}
    <TitleBlock slots="heading, text" theme="lightest" mdxType="TitleBlock" />
    <h1 {...{
      "id": "be-in-great-company"
    }}>{`Be in great company`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/extensibility.html"
      }}>{`Explore the thousands of plugins and integrations designed for Creative Cloud.`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "300px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/6663f52c72b40ff39996e62e45b5b168/77434/designed-for-cc-sm.webp 300w"],
            "sizes": "(max-width: 300px) 100vw, 300px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/6663f52c72b40ff39996e62e45b5b168/a8a0d/designed-for-cc-sm.png 300w"],
            "sizes": "(max-width: 300px) 100vw, 300px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/6663f52c72b40ff39996e62e45b5b168/a8a0d/designed-for-cc-sm.png",
            "alt": "Creative Cloud",
            "title": "Creative Cloud",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    {/* 1 */}
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/1e22911a4698406d45b4bec19bc77c3d/1c148/google.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/1e22911a4698406d45b4bec19bc77c3d/6fa18/google.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/1e22911a4698406d45b4bec19bc77c3d/6fa18/google.png",
            "alt": "Google",
            "title": "Google",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "480px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/149ff0322891b6e07f647a937298a7f8/5530d/msft-teams.webp 320w", "/creative-cloud/static/149ff0322891b6e07f647a937298a7f8/263a4/msft-teams.webp 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/149ff0322891b6e07f647a937298a7f8/dd4a7/msft-teams.png 320w", "/creative-cloud/static/149ff0322891b6e07f647a937298a7f8/9aebd/msft-teams.png 480w"],
            "sizes": "(max-width: 480px) 100vw, 480px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/149ff0322891b6e07f647a937298a7f8/9aebd/msft-teams.png",
            "alt": "Microsoft Teams",
            "title": "Microsoft Teams",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "264px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/5da3d60ab9c8c3ae35fdb9bc588d20d5/3ffc2/slack.webp 264w"],
            "sizes": "(max-width: 264px) 100vw, 264px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/5da3d60ab9c8c3ae35fdb9bc588d20d5/df2dd/slack.png 264w"],
            "sizes": "(max-width: 264px) 100vw, 264px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/5da3d60ab9c8c3ae35fdb9bc588d20d5/df2dd/slack.png",
            "alt": "Slack",
            "title": "Slack",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "91.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/5530d/pantone.webp 320w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/0c8fb/pantone.webp 640w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/94b1e/pantone.webp 1280w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/0b34d/pantone.webp 1920w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/d5269/pantone.webp 2560w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/b8ab2/pantone.webp 3600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/8980b/pantone.jpg 320w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/56d4e/pantone.jpg 640w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/62aaf/pantone.jpg 1280w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/aaf92/pantone.jpg 1920w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/36eba/pantone.jpg 2560w", "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/31012/pantone.jpg 3600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/5534d49fc8231c0563f7537cabd37d62/62aaf/pantone.jpg",
            "alt": "Pantone",
            "title": "Pantone",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/2a2c3f8ae41e284b4d7c6535335bd423/1c148/wrike.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/2a2c3f8ae41e284b4d7c6535335bd423/6fa18/wrike.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/2a2c3f8ae41e284b4d7c6535335bd423/6fa18/wrike.png",
            "alt": "Wrike",
            "title": "Wrike",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br style={{
      "background": "rgb(245, 245, 245)"
    }} />
    {/* 2 */}
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/b3c54d5cda1e2487abaad7522a4a8ecd/1c148/asana.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/b3c54d5cda1e2487abaad7522a4a8ecd/6fa18/asana.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/b3c54d5cda1e2487abaad7522a4a8ecd/6fa18/asana.png",
            "alt": "Asana",
            "title": "Asana",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/c39ac949308c15afb0dbffd7906fe264/1c148/miro.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/c39ac949308c15afb0dbffd7906fe264/6fa18/miro.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/c39ac949308c15afb0dbffd7906fe264/6fa18/miro.png",
            "alt": "Miro",
            "title": "Miro",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "235px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.82978723404257%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/752c0aa442961f90688065a6df760e03/c30e5/tiled.webp 235w"],
            "sizes": "(max-width: 235px) 100vw, 235px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/752c0aa442961f90688065a6df760e03/5537a/tiled.jpg 235w"],
            "sizes": "(max-width: 235px) 100vw, 235px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/752c0aa442961f90688065a6df760e03/5537a/tiled.jpg",
            "alt": "Tiled",
            "title": "Tiled",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "248px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/941a5d9efd8af89cab577b4f36da7cc1/1c148/zeplin.webp 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/941a5d9efd8af89cab577b4f36da7cc1/6fa18/zeplin.png 248w"],
            "sizes": "(max-width: 248px) 100vw, 248px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/941a5d9efd8af89cab577b4f36da7cc1/6fa18/zeplin.png",
            "alt": "Zeplin",
            "title": "Zeplin",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image" width="20%" theme="lightest" isCentered mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "400px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/133134bbef7efa9e9caf26fcad6a9f80/5530d/mural.webp 320w", "/creative-cloud/static/133134bbef7efa9e9caf26fcad6a9f80/2276a/mural.webp 400w"],
            "sizes": "(max-width: 400px) 100vw, 400px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/133134bbef7efa9e9caf26fcad6a9f80/dd4a7/mural.png 320w", "/creative-cloud/static/133134bbef7efa9e9caf26fcad6a9f80/d9f49/mural.png 400w"],
            "sizes": "(max-width: 400px) 100vw, 400px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/133134bbef7efa9e9caf26fcad6a9f80/d9f49/mural.png",
            "alt": "Mural",
            "title": "Mural",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    {/* Product cards */}
    <div id="api-list"></div>
    <TitleBlock slots="heading, text" theme="lightest" mdxType="TitleBlock" />
    <h1 {...{
      "id": "extensible-creative-cloud-products-and-services"
    }}>{`Extensible Creative Cloud products and services`}</h1>
    <p>{`Many Creative Cloud apps and services are extensible through APIs, SDKs, and Events. Choose your favorite to get started.`}</p>
    <OldProductCardGrid clouds={clouds} products={products} filterByIds={[4, 6, 8, 5, 42, 3, 9, 7, 10, 11, 12, 13, 14, 15, 44]} mdxType="OldProductCardGrid" />
    {/* Summary block */}
    <SummaryBlock slots="image, heading, text, buttons" background="rgb(9, 90, 186)" mdxType="SummaryBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/5530d/cc-banner.webp 320w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/0c8fb/cc-banner.webp 640w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/94b1e/cc-banner.webp 1280w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/0b34d/cc-banner.webp 1920w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/d5269/cc-banner.webp 2560w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/da28f/cc-banner.webp 2880w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/dd4a7/cc-banner.png 320w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/0f09e/cc-banner.png 640w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/bbbf7/cc-banner.png 1280w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/ac7a9/cc-banner.png 1920w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/c7a69/cc-banner.png 2560w", "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/f9c26/cc-banner.png 2880w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/creative-cloud/static/0fb8a04886004a077a6a9c50c28a0fc2/bbbf7/cc-banner.png",
            "alt": "cc banner",
            "title": "cc banner",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "get-the-latest-news-for-creative-cloud-developers"
    }}>{`Get the latest news for Creative Cloud Developers`}</h2>
    <p>{`With the Creative Cloud Developer Newsletter and the Adobe Tech Blog, we offer regular content for anyone who creates plugins and integrations for the Creative Cloud family of products and services. Get updates in your inbox, in your RSS reader, or both!`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://adobe.ly/devnews"
        }}>{`Join the newsletter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://medium.com/adobetech"
        }}>{`Follow the blog`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      